import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { linkedSpaces } from '@atlassian/jira-servicedesk-knowledge-services';

import {
	FETCH_LINKED_SPACES,
	type FetchLinkedSpaceAction,
} from '../../state/actions/fetch-linked-spaces';
import { fetchLinkedSpacesFailure } from '../../state/actions/fetch-linked-spaces-failure';
import { fetchLinkedSpacesSuccess } from '../../state/actions/fetch-linked-spaces-success';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>) =>
	action$.ofType(FETCH_LINKED_SPACES).mergeMap((action: FetchLinkedSpaceAction) => {
		const { projectKey } = action.payload;
		return linkedSpaces(projectKey)
			.map((response) => fetchLinkedSpacesSuccess(response))
			.catch(() => Observable.of(fetchLinkedSpacesFailure()));
	});
